import React, { Component } from 'react';
import Switch from 'react-switch';
import { FormattedMessage } from 'react-intl';
import styles from '../fields.module.scss';

class Toggle extends Component {
  constructor(props) {
    super(props);
    const { fieldId, toggleAnswers } = this.props;
    this.state = {
      enableFormToggle: toggleAnswers?.[fieldId] || false
    };
  }

  setEnableToggle = (toggleValue) => {
  const { handleValueChange, fieldId }=this.props;
  this.setState({ enableFormToggle: toggleValue });
  handleValueChange(toggleValue, fieldId);
  };

  render() {
    const { enableFormToggle } = this.state;
    const { answer } = this.props;
    const enableTooggleData = answer.settings.enableToggleText ? answer.settings.enableToggleText: 'yes';
    const disableToggleData = answer.settings.disableToggleText ? answer.settings.disableToggleText: 'No';
    return (
      <div>
        <div className={styles.form_access1} style={{ display: 'flex' }}>
          <div style={{
            marginRight: '8px',
            color: '#8C9EA7',
            fontFamily: 'Lato, sans-serif',
            fontSize: '15px',
            lineHeight: '26px'
          }}
          >
            {enableFormToggle ? (
              <FormattedMessage id="toggle.custom.field" defaultMessage={enableTooggleData} />
            ) : (
              <FormattedMessage id="toggle.custom.field" defaultMessage={disableToggleData} />
            )}
          </div>

          <div styles={styles.toggle} style={{ marginTop: '5px' }}>
            <Switch
              checked={enableFormToggle}
              onChange={() => this.setEnableToggle(!enableFormToggle)
              }
              checkedIcon={false}
              onColor="#1ee649"
              uncheckedIcon={false}
              height={21}
              width={41}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Toggle;
